import React from 'react';
import { Mutation } from 'react-apollo';

import { queryMockExamStudentExamCards } from '../../GraphQL/query/StudentExam.query';
import { DeleteMockExamStudentExam } from '../../GraphQL/mutation/StudentExam.mutation';
import RemoveExamModal from '../../Components/RemoveExamModal';

const RemoveStudentExam = ({ roundCode, examCard, onClose, roundTitle }) => (
  <Mutation
    mutation={DeleteMockExamStudentExam}
    refetchQueries={[{ query: queryMockExamStudentExamCards, variables: { roundCode } }]}
  >
    {(removeStudentExam, { loading, error }) => (
      <RemoveExamModal
        roundTitle={roundTitle}
        examCard={examCard}
        onClose={onClose}
        onConfirm={() => {
          removeStudentExam({
            variables: { roundCode, studentExamCardId: examCard.id },
          });
        }}
      />
    )}
  </Mutation>
);

export default RemoveStudentExam;
